import * as React from 'react';
import iconUrl from '../../../assets/kickoff-branching-branched.svg';
import dottedUrl from '../../../assets/release-branch-diagram-before.svg';

interface BranchIconProps {
    isDotted: boolean;
}

const BranchIcon: React.FC<BranchIconProps> = (props: BranchIconProps) => {
    const icon = props.isDotted ? dottedUrl : iconUrl;

    return <img src={icon} style={props.isDotted ? {} : { transform: 'scaleY(-1)' }} />;
};

export default BranchIcon;
